import {
    Component,
    Output,
    EventEmitter,
    Input,
    OnChanges,
    SimpleChanges,
    AfterViewInit,
    ViewContainerRef,
    ViewChild,
    TemplateRef,
    OnInit
} from '@angular/core';
import {ElementRef, Renderer2} from '@angular/core';

// Data Model
import {SortModel, CommonService} from 'abs-ngx-library/src/lib/core';

declare let $: any;

function _window(): any {
    return window;
}
@Component({
    selector: 'sort-by',
    templateUrl: './sort-by-al-v1.component.html'
})

export class SortAlV1Component implements OnInit, OnChanges, AfterViewInit {
    @ViewChild('sortDropdownItemContainer', { read: ViewContainerRef, static: true } ) sortDropdownItemContainer: ViewContainerRef;
    @ViewChild('themeBuilderEnabledTemplate', { read: TemplateRef, static: true }) themeBuilderEnabledTemplate: TemplateRef<any>;
    @ViewChild('defaultTemplate', { read: TemplateRef, static: true }) defaultTemplate: TemplateRef<any>;
    @ViewChild('DSTV2Template', { read: TemplateRef, static: true }) DSTV2Template: TemplateRef<any>;

    @Input() sortRules: SortModel[];
    @Input() activeSortRule: SortModel;
    @Output() activeSortRuleEmitter: EventEmitter<SortModel> = new EventEmitter<SortModel>();
    @ViewChild('sortId', { static: true }) el: ElementRef;

    public arriaExpanded: boolean = false;
    public selectedSortRuleIndex: number;
    public defaultSorted: boolean = false;
    public isThemeBuilderEnabled: boolean;
    public enableDstV2Theme: boolean;
    
    constructor(private rd: Renderer2, private _commonService:CommonService) {
        this.isThemeBuilderEnabled = _window().SWY.CONFIGSERVICE.isThemeBuilderEnabled;
        this.enableDstV2Theme = this._commonService.hasPageV2Theme();
    }

    public doSortEmitter(activeSortRule: SortModel) {
        this.activeSortRule = activeSortRule;
        this.activeSortRuleEmitter.emit(this.activeSortRule);
        
        // update datalayer
        if (window['AB']['DATALAYER'] && this.activeSortRule && this.activeSortRule.label) {
            window['AB']['DATALAYER'].sortBy(this.activeSortRule.label);
        }
    }

    /**
     * Triggered on properties changes - Search and update new active sort rule index
     *
     * @param {SimpleChanges} changes properties that has been changed
     */
    public ngOnChanges(changes: SimpleChanges): void {

        if (changes.activeSortRule) {
            this.sortRules.forEach(
                (sort, i) => {

                    if (this.activeSortRule && sort.field === this.activeSortRule.field) {
                        this.selectedSortRuleIndex = i;
                        sort.selected = true;
                        this.defaultSorted = true;

                    } else {
                        sort.selected = null;
                    }
                }
            );
        }
    }

    /**
     * Call Accessibility ARIA methods
     */
    public ngAfterViewInit(): void {

        this.sortByComponent();

        //README: Code is not currently used commenting for now 
        // if (!this.el.nativeElement) {
        //     console.log('sortID NO detected');

        // } else {
        //     console.log('sortID YES detected');

        //     this.el.nativeElement.style.background = 'white';
        //     this.el.nativeElement.style.border = '0px solid';
        // }
    }

    public ngOnInit(): void {
        this.loadSortDropdownItemContainer();
    }

    public loadSortDropdownItemContainer() {
        switch(true) {
            case this.enableDstV2Theme:
                this.sortDropdownItemContainer.createEmbeddedView(this.DSTV2Template);
            break;
            case this.isThemeBuilderEnabled:
                this.sortDropdownItemContainer.createEmbeddedView(this.themeBuilderEnabledTemplate);
            break;
            default:
                this.sortDropdownItemContainer.createEmbeddedView(this.defaultTemplate);
            break;
        }
    }

    /* Sort by, Angular dropdown component ARIA , Taken from ARIA.JS*/
    public sortByComponent = function () {
        const sortBy = $('.dropdown-sort-by.dropdown');

        $('.sort-by-text').focusout(function () {
            $(this).css('outline', 'none');
        });

        /* aria-expanded removed when dropdown list is hidden + focus changing*/
        sortBy.on('hidden.bs.dropdown', function (e: any) {
            e.preventDefault();
            setTimeout(function () {
                $('#sortByID').focus();
            }, 300);
        });

        // to add the showPromo class for filters in mobile view
        if ($('div.cfh-banner.cfh-banner__search').length > 0) {
            $('#filterMV').addClass('showPromo');
        }

        $(document).not('.squaredThree').on('click', 'label', function (e: any) {
            $(this).css('outline', 'none');
        });

        $('.label-more').on('click', function (e: any) {
            $(this).prev().children(':eq(5)').children('label').css('outline', 'none');
        });
    };

    public removeVowels(option) {
        return  option.toLowerCase().replace(/ /g, '').replace(/[aeiou]/g, '');
    }
}
